module.exports = __webpack_public_path__ + "img/laos.74bf0d75.svg";